<script>
export default {
  name: "UsersView",
  created() {
    document.title = "Clients";
  },
  methods: {
    // An import can create or modify rows, so reload the table afterwards.
    refreshList() {
      if (this.$refs.list) this.$refs.list.initialize();
    },
  },
};
</script>

<template>
  <v-container>
    <v-row>
      <v-col>
        <ListUsersComponent ref="list"></ListUsersComponent>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <ImportExportComponent @imported="refreshList"></ImportExportComponent>
      </v-col>
    </v-row>
  </v-container>
</template>
